import React from 'react';
import { Edit, Eye, EyeOff, Trash2 } from 'lucide-react';

interface PostActionsProps {
  isAdmin: boolean;
  isSuperAdmin: boolean;
  hidden: boolean;
  onEdit?: () => void;
  onHide?: () => void;
  onUnhide?: () => void;
  onDelete?: () => void;
}

const PostActions: React.FC<PostActionsProps> = ({
  isAdmin,
  isSuperAdmin,
  hidden,
  onEdit,
  onHide,
  onUnhide,
  onDelete
}) => {
  return (
    <div className="flex items-center space-x-2">
      {isAdmin && onEdit && (
        <button onClick={onEdit} className="text-blue-600 hover:text-blue-800" title="Edit">
          <Edit className="w-5 h-5" />
        </button>
      )}
      {isAdmin && !hidden && onHide && (
        <button onClick={onHide} className="text-red-600 hover:text-red-800" title="Hide">
          <Eye className="w-5 h-5" />
        </button>
      )}
      {isAdmin && hidden && onUnhide && (
        <button onClick={onUnhide} className="text-green-600 hover:text-green-800" title="Unhide">
          <EyeOff className="w-5 h-5" />
        </button>
      )}
      {isSuperAdmin && hidden && onDelete && (
        <button onClick={onDelete} className="text-red-900 hover:text-red-700" title="Delete">
          <Trash2 className="w-5 h-5" />
        </button>
      )}
    </div>
  );
};

export default PostActions; 